module.exports = __webpack_public_path__ + "c244f6de0c8a07185fe48fef81c18457.svg";